module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAAQUlEQVQ4jWP8//vXfwYKAQuI6Ju9lizNRanBYJqJUlfAXYJuMiGA7nKquGTUkFFDiAEoKZbcPEQVlzBSoyigiksA6NsP421YzFEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/sougou/kjtb1-10.png
// module id = 933
// module chunks = 0